import { createContext, useContext } from 'react';

export interface AlarmGroupTimeContextType {
  /**
   * Current seeker timestamp in ms
   */
  seekerTimestamp: number;
  /**
   * Whether the timeline is paused or not
   */
  isSeekerPaused: boolean;
  /**
   * Playback speed at which the video / frames are playing
   */
  playbackSpeed: number;
  /**
   * Seek to a specific time in the timeline in ms
   */
  seekTo: (time: number) => void;
  /**
   * Toggle the seeker paused state
   */
  toggleSeekerPaused: () => void;
  /**
   * Update the playback speed at which the video / frames are playing
   */
  updatePlaybackSpeed: (speed: number) => void;
}

export const AlarmGroupTimeContext = createContext<AlarmGroupTimeContextType>({
  seekerTimestamp: 0,
  isSeekerPaused: false,
  playbackSpeed: 1,
  seekTo: () => ({}),
  toggleSeekerPaused: () => ({}),
  updatePlaybackSpeed: () => ({}),
});

export const useAlarmGroupTime = () => useContext(AlarmGroupTimeContext);
